import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { monitoringStateSelector } from '@/modules/editorial/bulkActions/redux/selectors';
import { queueSelector } from '@/modules/uploaderNew/redux/selectors';

import ViewportDraggable from '@/modules/@common/ViewportDraggable/ViewportDraggable';
import BulkActionsStatusDialog
  from '@/modules/editorial/bulkActions/components/BulkActionStatusDialog/BulkActionStatusDialog';
import MultiUploadStatusDialog from '@/modules/uploaderNew/components/MultiUploadStatusDialog';

import styles from './ProgressDialog.module.scss';

const UPLOAD_PROGRESS_TYPE = 'upload-progress';
const BULK_PROGRESS_TYPE = 'bulk-progress';

const Components = {
  [UPLOAD_PROGRESS_TYPE]: MultiUploadStatusDialog,
  [BULK_PROGRESS_TYPE]: BulkActionsStatusDialog,
};

function ProgressDialog() {
  const [slots, setSlots] = useState([]);

  const queue = useSelector(queueSelector);
  const bulkActionsMonitoringState = useSelector(monitoringStateSelector);

  useEffect(() => {
    if (Object.keys(queue).length) {
      setSlots([UPLOAD_PROGRESS_TYPE, BULK_PROGRESS_TYPE]);
    }
  }, [queue]);

  useEffect(() => {
    if (bulkActionsMonitoringState.length) {
      setSlots([BULK_PROGRESS_TYPE, UPLOAD_PROGRESS_TYPE]);
    }
  }, [bulkActionsMonitoringState]);

  return (
    <ViewportDraggable className={styles.Wrapper}>
      { slots.map((slotType, slotIndex) => {
        const Component = Components[slotType];
        const props = {};
        if (slotIndex === 1) {
          props.headerWithoutRadius = true;
        }
        return Component ? <Component {...props} /> : null;
      }) }
    </ViewportDraggable>
  );
}

export default ProgressDialog;
